import React, { useEffect } from 'react';
import './intro.css';
import bgimg from '../../assets/intro-img2.png';
import bgicon from '../../assets/suitcase.png';
import { Link } from 'react-scroll';
import AOS from 'aos';

const Intro = () => {
  useEffect(() => {
    AOS.init(); // Initialize AOS
  }, []);

  return (
    <section className="intro" id='home'>
      <div className='container intro-container col-lg-12 align-items-center mt-5 d-flex flex-wrap justify-content-center justify-content-lg-between'>
        <div className='col-lg-6' data-aos="fade-up">
          <h6 className='hello'><span className="introText">Hello </span></h6>
          <h1 className='introText'>I'm <span className="introText">Amul Raj S</span><br />Technical Lead &<br /> Full Stack developer</h1>
          <p className="introPara">Technical Lead with 4+ years of experience in web operations, technical project delivery, development, SEO optimization, CRM integrations, and team management. Proven expertise in leading cross-functional teams, streamlining workflows, and delivering high-quality web solutions.</p>
          <Link to="contact" smooth={true} duration={500}><button type="button" className="mb-4 btn btn-light d-flex align-items-center gap-2"><img src={bgicon} alt='' className='bgicon' /> Hire Me</button></Link>
        </div>
        <div className='bg-img col-lg-5' data-aos="fade-up">
          <img src={bgimg} alt='' className='bgimg rounded' />
        </div>
      </div>
    </section>
  );
}

export default Intro;
